import { Stack } from '@mui/material';
import { CustomMetaTitle } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Title } from './Title';
import { BankDetailsForm } from './BankDetailsForm';

interface IUpdateBankDetails {
  nextStep: () => void;
}

export const UpdateBankDetails = ({ nextStep }: IUpdateBankDetails) => {
  return (
    <>
      <CustomMetaTitle title={Dictionary[DICTIONARY.UpdateBankDetails].title} />
      <Stack alignItems='center' gap='40px'>
        <Title />
        <BankDetailsForm nextStep={nextStep} />
      </Stack>
    </>
  );
};
